<template>
  <div>
    <pageHeader :headerIcon="''"
                :headerText="$t(currentTab)"
                :haveFilterInput="false"
                :hasIcon="false"
                :columnsNumber="['eight wide column', 'three wide column', 'five wide column']">
    </pageHeader>
    <div class="ui grid" style="padding-top: 15px">
      <div class="three wide column">
        <div class="ui vertical secondary pointing menu" style="width: 100%">
          <a class="item" :class="{ active: currentTab === tabs.first }"
             @click="currentTab = tabs.first">
            Packages
          </a>
          <a class="item" :class="{ active: currentTab === tabs.second }"
             @click="currentTab = tabs.second">
            Add room
          </a>
        </div>
      </div>
      <div class="twelve wide column">
        <div v-if="currentTab === tabs.first" style="margin-top: 10px">
          <packagesPart />
        </div>
        <div v-if="currentTab === tabs.second" style="margin-top: 10px">
          <roomForm />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {
    packagesPart: require('@/components/clinics/clinic_components/packages/Packages').default,
    roomForm: require('@/components/rooms/RoomForm.vue').default,
    pageHeader: require('@/components/abstract_components/PageHeader').default
  },
  data () {
    return {
      loading: true,
      tabs: {
        first: 'Packages',
        second: 'Add room'
      },
      currentTab: 'Packages'
    }
  }
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/clinics/Settings.vue